'use client';
import LogoIcon from '/public/logo.svg';
import { siteConfig } from '@/lib/site';
import { cn, getStaticUrl } from '@/lib/utils';
import Link from 'next/link';
import { useI18n } from '@/hooks/use-i18n';

interface BackgroundProps {
  className?: string;
  imageUrl?: string;
  videoUrl?: string;
}

export default function Background({
  className,
  imageUrl,
  videoUrl = getStaticUrl('/web/static/images/icons/frontpage.mp4'),
}: BackgroundProps) {
  const { t } = useI18n('auth');

  const TAGS = [
    t('background.tags.multiPlatform'),
    t('background.tags.secure'),
    t('background.tags.intelligent'),
    t('background.tags.realtime'),
    t('background.tags.decision'),
  ];

  return (
    <div
      className={cn(
        `relative bg-[url('${imageUrl || '/bg.png'}')] bg-cover bg-center h-full w-full px-[10px] flex flex-col justify-center`,
        className,
      )}
    >
      {videoUrl && (
        <div className="absolute left-0 top-0 w-full h-full overflow-hidden">
          <video
            autoPlay
            muted
            loop
            playsInline
            poster="/bg.png"
            preload="auto"
            controls={false}
            onContextMenu={(e) => e.preventDefault()}
            className="absolute top-1/2 left-1/2 min-w-full min-h-full w-auto h-auto -translate-x-1/2 -translate-y-1/2 object-cover"
          >
            <source src={videoUrl} type="video/mp4" />
          </video>
        </div>
      )}

      <Link href="/">
        <div className="items-center gap-[4px] absolute top-[20px] left-[16px] hidden lg:flex z-10">
          <LogoIcon width={20} height={20} />
          <span className="text-[20px] font-[700] text-[rgba(0, 0, 0, 0.75)]">
            {siteConfig.name?.toUpperCase()}
          </span>
        </div>
      </Link>
      <div className="flex flex-wrap items-center justify-center text-[40px] max-lg:text-[30px] text-white font-[600] z-10 lg:leading-[56px]">
        <div>{siteConfig.name?.toUpperCase()}</div>
        <div className="hidden lg:block">，</div>
        <div className="flex justify-center text-center">
          {t('background.slogan')}
        </div>
      </div>
      <div className="flex items-center justify-center gap-4 flex-wrap mt-[5px] max-md:mt-4 z-10">
        {TAGS.map((tag) => (
          <span
            key={tag}
            className="flex items-center whitespace-nowrap text-[14px] text-white px-3 py-1 font-[600] rounded-[100px] bg-[rgba(0,0,0,0.5)] shadow-[0_0_8px_0_rgba(0,0,0,0.4)]"
          >
            {tag}
          </span>
        ))}
      </div>
    </div>
  );
}
